import { render, staticRenderFns } from "./ButtonNew.vue?vue&type=template&id=816ebaee&scoped=true&"
import script from "./ButtonNew.vue?vue&type=script&lang=js&"
export * from "./ButtonNew.vue?vue&type=script&lang=js&"
import style0 from "./ButtonNew.vue?vue&type=style&index=0&id=816ebaee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816ebaee",
  null
  
)

export default component.exports